export enum UpdateTypes {
  LAB = 'labResult',
  PATHOLOGY = 'pathologyReport',
  IMAGING = 'imagingReport',
  VISIT_SUMMARY = 'visitSummary',
  MEDICATIONS = 'medications'
}
